import { render, staticRenderFns } from "./table-payroll.vue?vue&type=template&id=275c9888&scoped=true"
import script from "./table-payroll.vue?vue&type=script&lang=js"
export * from "./table-payroll.vue?vue&type=script&lang=js"
import style0 from "./table-payroll.vue?vue&type=style&index=0&id=275c9888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c9888",
  null
  
)

export default component.exports